export var AnchorReference;
(function (AnchorReference) {
    AnchorReference[AnchorReference["anchorEl"] = 0] = "anchorEl";
    AnchorReference[AnchorReference["anchorPosition"] = 1] = "anchorPosition";
    AnchorReference[AnchorReference["none"] = 2] = "none";
})(AnchorReference || (AnchorReference = {}));
//# sourceMappingURL=Menu.types.js.map